
























import { Component, Vue, Prop } from 'vue-property-decorator'
import avatar from '@/components/avatar/index.vue'
import { AppModule } from '@/store/modules/app'
import cell from './simpleCell.vue'
@Component({
  name: 'UpComing',
  components: {
    avatar,
    cell
  }
})
export default class extends Vue {
  @Prop({ default: () => void 0 }) private item!: any
  private get member () {
    return AppModule.workerMap[this.item.createUser] || {}
  }
  private get workFlowNodeName () {
    if (this.item.state === 'success') {
      return  '审批通过' 
    } else if (this.item.state === 'failure') {
      return  '审批未通过' 
    } else {
      return this.item.workFlowNodeName
    }
  }
}
